import React from 'react';
import { ShieldCheck } from 'lucide-react';
import VaultSheet from '../../pages/vault/components/VaultSheet';
import ConsumerAuthForms, { AuthTab } from './ConsumerAuthForms';

interface ConsumerAuthSheetProps {
  open: boolean;
  onClose: () => void;
  /** The visitor is signed in (after the email code, a log in, or a password reset). */
  onAuthSuccess: (result: { allowBrand: boolean }) => void;
  defaultTab?: AuthTab;
  // The brand of the piece being saved, for the "send me news" choice.
  brandName?: string;
  // The piece being saved: its photo heads the sheet (#467).
  imageUrl?: string;
}

// The sign-in sheet of the product page's Save flow: the piece it saves, a
// line on what the vault is, and the forms, all in the sheet (#467, round 2).
const ConsumerAuthSheet: React.FC<ConsumerAuthSheetProps> = ({ open, onClose, onAuthSuccess, defaultTab = 'signup', brandName, imageUrl }) => (
  <VaultSheet open={open} onClose={onClose} label="Your free vault" tall zIndex={75}>
    <div className="mb-5 flex items-center gap-3">
      {imageUrl ? (
        <img src={imageUrl} alt="" className="h-14 w-14 shrink-0 rounded-[8px] bg-white object-cover" />
      ) : (
        <span className="grid h-14 w-14 shrink-0 place-items-center rounded-[8px] bg-[var(--v-glass-2)]">
          <ShieldCheck size={22} className="text-[var(--v-accent)]" />
        </span>
      )}
      <div className="min-w-0">
        <h3 className="v-display text-[19px] font-semibold leading-tight">Keep it in your vault</h3>
        <p className="mt-0.5 text-[13.5px] leading-snug text-[var(--v-text-2)]">
          Free. Your pieces, their care labels and proof they're verified.
        </p>
      </div>
    </div>
    {open && <ConsumerAuthForms defaultTab={defaultTab} brandName={brandName} onDone={onAuthSuccess} />}
  </VaultSheet>
);

export default ConsumerAuthSheet;
